import { useEffect, useState } from "react";
import AdminSidebar from "../components/AdminSidebar";

const API_BASE = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;

export default function AdminNewsletterPage() {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const token = localStorage.getItem("adminToken");
  const headers = { Authorization: `Bearer ${token}` };

  const fetchSubscribers = () => {
    setLoading(true);
    fetch(`${API_BASE}/newsletter/admin`, { headers })
      .then((r) => r.json())
      .then((json) => setSubscribers(json.success ? json.data : []))
      .finally(() => setLoading(false));
  };

  useEffect(fetchSubscribers, []);

  const handleToggle = async (id) => {
    await fetch(`${API_BASE}/newsletter/admin/${id}/toggle`, {
      method: "PATCH",
      headers,
    });
    fetchSubscribers();
  };

  const shown = subscribers.filter((s) =>
    `${s.fullName || ""} ${s.email}`
      .toLowerCase()
      .includes(search.toLowerCase()),
  );

  const activeCount = subscribers.filter((s) => s.isActive).length;

  return (
    <div className="bg-[#f7f9fb] font-['Plus_Jakarta_Sans'] min-h-screen">
      <AdminSidebar />
      <main className="pt-16 md:pt-2 md:ml-64 min-h-screen p-8">
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-[#00255a] mb-2">
            Newsletter Subscribers
          </h2>
          <p className="text-[#64748b]">
            {activeCount} active of {subscribers.length} total. Only active
            subscribers receive new-opening emails.
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-[#e2e8f0] shadow-sm overflow-hidden">
          <div className="p-5 border-b border-[#e2e8f0]">
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by name or email…"
              className="w-full md:w-96 px-4 py-2.5 rounded-lg border border-[#c4c6d1] outline-none focus:ring-2 focus:ring-[#00255a]/10 text-sm"
            />
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead className="bg-[#f2f4f6]">
                <tr>
                  {["Name", "Email", "Phone", "Subscribed", "Status", ""].map(
                    (h) => (
                      <th
                        key={h}
                        className="px-6 py-4 text-xs uppercase text-[#64748b]"
                      >
                        {h}
                      </th>
                    ),
                  )}
                </tr>
              </thead>
              <tbody className="divide-y divide-[#e2e8f0]">
                {loading ? (
                  <tr>
                    <td colSpan="6" className="p-12 text-center text-[#64748b]">
                      Loading...
                    </td>
                  </tr>
                ) : shown.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="p-12 text-center text-[#64748b]">
                      No subscribers found.
                    </td>
                  </tr>
                ) : (
                  shown.map((s) => (
                    <tr
                      key={s.id}
                      className="hover:bg-[#f7f9fb] transition-colors"
                    >
                      <td className="px-6 py-4 font-semibold text-[#00255a]">
                        {s.fullName || "—"}
                      </td>
                      <td className="px-6 py-4 text-sm text-[#0f172a]">
                        {s.email}
                      </td>
                      <td className="px-6 py-4 text-sm text-[#64748b]">
                        {s.phone || "—"}
                      </td>
                      <td className="px-6 py-4 text-sm text-[#64748b]">
                        {new Date(s.createdAt).toLocaleDateString()}
                      </td>
                      <td className="px-6 py-4">
                        <button onClick={() => handleToggle(s.id)}>
                          <span
                            className={`px-3 py-1 rounded-full text-xs font-bold inline-flex items-center gap-1 ${
                              s.isActive
                                ? "bg-emerald-100 text-emerald-700"
                                : "bg-[#e0e3e5] text-[#44474f]"
                            }`}
                          >
                            <span
                              className={`w-1.5 h-1.5 rounded-full ${s.isActive ? "bg-emerald-500" : "bg-[#747781]"}`}
                            />
                            {s.isActive ? "Active" : "Unsubscribed"}
                          </span>
                        </button>
                      </td>
                      <td className="px-6 py-4 text-right text-xs text-[#94a3b8]">
                        Click status to toggle
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
}
